// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.err[data-v-1e157a4e] {\r\n  margin-top: 2px !important;\r\n  color: #eb5757;\r\n  font-size: 12px;\r\n  min-height: 20px;\r\n  white-space: nowrap;\r\n  margin-bottom: -30px;\r\n  line-height: 20px;\r\n  font-weight: 500;\r\n  padding-left: 2px;\n}\r\n", ""]);
// Exports
module.exports = exports;
